// src/components/organism/CreateSix/CreateSixStepper.tsx
import React from "react";
import { useSelector } from "react-redux";

import { selectStep } from "@/store/selectors/createSix";
import { getStepConfig } from "@/components/organism/CreateSix/stepConfig";

interface StepperProps {
  onClose: () => void;
}
const CreateSixStepper: React.FC<StepperProps> = ({ onClose }) => {
  const step = useSelector(selectStep);
  const { component: StepComponent } = getStepConfig(step);
  return <StepComponent onClose={onClose} />;
};

export default CreateSixStepper;
